<template>
  <div style="margin: 0 24px 8px;">
    <el-form ref="formRef" :model="supplierForm" label-width="auto" label-position="right">
      <el-form-item label="供应商：">
        <el-input v-model="supplierForm.name" placeholder="请输入供应商名称" />
      </el-form-item>
      <el-form-item label="联系人：">
        <el-input v-model="supplierForm.contact" placeholder="请输入联系人" />
      </el-form-item>
      <el-form-item label="联系电话：">
        <el-input v-model="supplierForm.phone" placeholder="请输入联系电话"/>
      </el-form-item>
      <el-form-item label="微信：">
        <el-input v-model="supplierForm.wechat" placeholder="请输入微信" />
      </el-form-item>
      <el-form-item label="发货地址：">
        <el-input v-model="supplierForm.shipAddress" placeholder="请输入发货地址" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"/>
      </el-form-item>
      <el-form-item label="备注：">
        <el-input v-model="supplierForm.remark" placeholder="请输入备注" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"/>
      </el-form-item>
      <el-form-item label="排序：">
        <el-input v-model="supplierForm.orderNum" placeholder="请输入数值" />
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center; margin-top: 24px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData } from "@/api/api"
import { addOrUpdateSupplier, getSysPositionList } from "@/api/url";
import { phoneReg } from "@/assets/shared/reg-constant";

export default {
  name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
    return {
      supplierForm: this.value.supplierForm,
      idx: this.value.ids,
    }
  },
  methods: {

    cancel() {
      this.$emit("close");
    },
    summit() {
      console.log(this.idx)
      if(!this.supplierForm.name) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入供应商名称',
          type: 'warning'
        });
        return false
      }
      if(!this.supplierForm.orderNum) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入排序数值，数值越大越靠前',
          type: 'warning'
        });
        return false
      }
      // if(this.supplierForm.phone && !phoneReg.test(this.supplierForm.phone)){
      //   this.$message({
      //     showClose: true,
      //     duration: 2000,
      //     message: '请输入正确的联系电话',
      //     type: 'warning'
      //   });
      //   return false
      // }
      let param = {}

      param['id'] = this.idx > -1?this.supplierForm.id:0;
      param['name'] = this.supplierForm.name;
      param['contact'] = this.supplierForm.contact;
      param['phone'] = this.supplierForm.phone;
      param['wechat'] = this.supplierForm.wechat;
      param['shipAddress'] = this.supplierForm.shipAddress;
      param['remark'] = this.supplierForm.remark;
      param['orderNum'] = this.supplierForm.orderNum;
      postFormData(addOrUpdateSupplier, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },

    // getPositionList() {
    //   getFormData(getSysPositionList).then(data=> {
    //     this.positionTypeArray = data.data
    //   })
    // },



  },
  mounted() {

  }
}
</script>

<style scoped>

</style>
